import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { AppShell, ProtectedRoute } from "@/components/AppShell";

import HomePage from "@/pages/HomePage";
import WhatIsNpsPage from "@/pages/WhatIsNpsPage";
import NpsCalculatorPage from "@/pages/NpsCalculatorPage";
import TemplatesPage from "@/pages/TemplatesPage";
import PricingPage from "@/pages/PricingPage";
import BlogPage from "@/pages/BlogPage";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import PublicSurveyPage from "@/pages/PublicSurveyPage";

import DashboardPage from "@/pages/app/DashboardPage";
import SurveysPage from "@/pages/app/SurveysPage";
import SurveyWizardPage from "@/pages/app/SurveyWizardPage";
import SurveyBuilderPage from "@/pages/app/SurveyBuilderPage";
import SurveyAnalyticsPage from "@/pages/app/SurveyAnalyticsPage";
import TransactionsPage from "@/pages/app/TransactionsPage";
import AppTemplatesPage from "@/pages/app/AppTemplatesPage";
import JourneysPage from "@/pages/app/JourneysPage";
import AiInsightsPage from "@/pages/app/AiInsightsPage";
import TicketsPage from "@/pages/app/TicketsPage";
import CustomersPage from "@/pages/app/CustomersPage";
import AnalyticsStudioPage from "@/pages/app/AnalyticsStudioPage";
import ReportsPage from "@/pages/app/ReportsPage";
import TeamPage from "@/pages/app/TeamPage";
import SettingsPage from "@/pages/app/SettingsPage";

import SuperAdminOverview from "@/pages/admin/SuperAdminOverview";
import SuperAdminTenants from "@/pages/admin/SuperAdminTenants";

function ProtectedShell({ children, role }) {
  return (
    <ProtectedRoute role={role}>
      <AppShell>{children}</AppShell>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Marketing */}
            <Route path="/" element={<HomePage />} />
            <Route path="/what-is-nps" element={<WhatIsNpsPage />} />
            <Route path="/calculator" element={<NpsCalculatorPage />} />
            <Route path="/templates" element={<TemplatesPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/blog" element={<BlogPage />} />

            {/* Auth */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />

            {/* Public response (respondents) */}
            <Route path="/r/:slug" element={<PublicSurveyPage />} />

            {/* Tenant app */}
            <Route path="/app" element={<ProtectedShell><DashboardPage /></ProtectedShell>} />
            <Route path="/app/surveys" element={<ProtectedShell><SurveysPage /></ProtectedShell>} />
            <Route path="/app/surveys/new" element={<ProtectedShell><SurveyWizardPage /></ProtectedShell>} />
            <Route path="/app/surveys/:id" element={<ProtectedShell><SurveyBuilderPage /></ProtectedShell>} />
            <Route path="/app/surveys/:id/analytics" element={<ProtectedShell><SurveyAnalyticsPage /></ProtectedShell>} />
            <Route path="/app/templates" element={<ProtectedShell><AppTemplatesPage /></ProtectedShell>} />
            <Route path="/app/journeys" element={<ProtectedShell><JourneysPage /></ProtectedShell>} />
            <Route path="/app/tickets" element={<ProtectedShell><TicketsPage /></ProtectedShell>} />
            <Route path="/app/customers" element={<ProtectedShell><CustomersPage /></ProtectedShell>} />
            <Route path="/app/transactions" element={<ProtectedShell><TransactionsPage /></ProtectedShell>} />
            <Route path="/app/analytics" element={<ProtectedShell><AnalyticsStudioPage /></ProtectedShell>} />
            <Route path="/app/reports" element={<ProtectedShell><ReportsPage /></ProtectedShell>} />
            <Route path="/app/ai" element={<ProtectedShell><AiInsightsPage /></ProtectedShell>} />
            <Route path="/app/team" element={<ProtectedShell><TeamPage /></ProtectedShell>} />
            <Route path="/app/settings" element={<ProtectedShell><SettingsPage /></ProtectedShell>} />

            {/* Super admin */}
            <Route path="/admin" element={<ProtectedShell role="super_admin"><SuperAdminOverview /></ProtectedShell>} />
            <Route path="/admin/tenants" element={<ProtectedShell role="super_admin"><SuperAdminTenants /></ProtectedShell>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
